const gsapText = gsap => {
  const text = document.querySelectorAll('.gsap_text');
  text.forEach(item => {
    gsap.from(item, {
      yPercent: 100,
      duration: 0.3,
      ease: 'power4.inout',
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        once: true,
      },
    });
  });
};
export default gsapText;
